import React, { useEffect, useState } from "react";

// import ARIMA from "arima";
import { Chart } from "react-google-charts";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";



import { pega_estimativa_geral, PegarDados1, PegarDados2 } from "../../services/api";

const Estimativa_geral = (props) => {

    // Função para calcular a média móvel de três anos
    const movingAverage = (n1, n2, n3) => (n1 + n2 + n3) / 3;

    // Função para calcular o crescimento linear
    const linearGrowth = (n1, n4) => n1 + (n1 - n4) / 3;

    // Função para calcular CAGR
    const calculateCAGR = (valorFinal, valorInicial, anos) => {
        return ((valorFinal / valorInicial) ** (1 / anos)) - 1;
    };

    // // Função para calcular estimativas ARIMA
    // const estimateARIMA = (historicalData) => {
    //     const arima = new ARIMA({ p: 1, d: 1, q: 1 }).train(historicalData);
    //     const [prediction] = arima.predict(1);
    //     return prediction;
    // };

    const [dados, setDados] = useState('');

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio']


    const fetchData = async () => {
        try {
            const response = await pega_estimativa_geral();
            console.log("response estima", response)
            setDados(response);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("dados estima", dados);

    useEffect(() => {
        fetchData();
    }, []);

    // Função para calcular as estimativas usando diferentes métodos

    const calcularEstimativas = (dado) => {
        // Linear Growth
        const estimativaNovosLinear = linearGrowth(parseInt(dado.n2024), parseInt(dado.n2021));
        const estimativaRenovadosLinear = linearGrowth(parseInt(dado.r2024), parseInt(dado.r2021));
        const estimativaTotalLinear = estimativaNovosLinear + estimativaRenovadosLinear;

        // CAGR
        const anos = 3; // De 2021 a 2024
        const cagrNovos = calculateCAGR(parseInt(dado.n2024), parseInt(dado.n2021), anos);
        const cagrRenovados = calculateCAGR(parseInt(dado.r2024), parseInt(dado.r2021), anos);
        const estimativaNovosCAGR = parseInt(dado.n2024) * (1 + cagrNovos);
        const estimativaRenovadosCAGR = parseInt(dado.r2024) * (1 + cagrRenovados);
        const estimativaTotalCAGR = estimativaNovosCAGR + estimativaRenovadosCAGR;

        // Média Móvel
        const estimativaNovosMovel = movingAverage(parseInt(dado.n2024), parseInt(dado.n2023), parseInt(dado.n2022));
        const estimativaRenovadosMovel = movingAverage(parseInt(dado.r2024), parseInt(dado.r2023), parseInt(dado.r2022));
        const estimativaTotalMovel = estimativaNovosMovel + estimativaRenovadosMovel;

        // // ARIMA (usando dados históricos de novos alunos)
        // const novosHistorico = [dado.n2021, dado.n2022, dado.n2023, dado.n2024];
        // const renovadosHistorico = [dado.r2021, dado.r2022, dado.r2023, dado.r2024];
        // const estimativaNovosARIMA = estimateARIMA(novosHistorico);
        // const estimativaRenovadosARIMA = estimateARIMA(renovadosHistorico);
        // const estimativaTotalARIMA = estimativaNovosARIMA + estimativaRenovadosARIMA;

        return {
            estimativaNovosLinear,
            estimativaRenovadosLinear,
            estimativaTotalLinear,
            estimativaNovosCAGR,
            estimativaRenovadosCAGR,
            estimativaTotalCAGR,
            estimativaNovosMovel,
            estimativaRenovadosMovel,
            estimativaTotalMovel
            // estimativaNovosARIMA,
            // estimativaRenovadosARIMA,
            // estimativaTotalARIMA
        };
    };
    if (dados !== '') {
        return (
            <div>
                <h1>Estimativas para 2025 - Alunos Novos, Renovados e Total</h1>
                <table border="1">
                    <thead>
                        <tr>
                            <th>Unidade</th>
                            <th>Estimativa Novos Linear (2025)</th>
                            <th>Estimativa Renovados Linear (2025)</th>
                            <th>Estimativa Total Linear (2025)</th>
                            <th>Estimativa Novos CAGR (2025)</th>
                            <th>Estimativa Renovados CAGR (2025)</th>
                            <th>Estimativa Total CAGR (2025)</th>
                            <th>Estimativa Novos Movel (2025)</th>
                            <th>Estimativa Renovados Movel (2025)</th>
                            <th>Estimativa Total Movel (2025)</th>
                            {/* <th>Estimativa Novos ARIMA (2025)</th>
                                <th>Estimativa Renovados ARIMA (2025)</th>
                                <th>Estimativa Total ARIMA (2025)</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {dados.map((dado) => {
                            const estimativas = calcularEstimativas(dado);
                            return (
                                <tr key={dado.unidade}>
                                    <td>{dado.unidade}</td>
                                    <td>{estimativas.estimativaNovosLinear.toFixed(2)}</td>
                                    <td>{estimativas.estimativaRenovadosLinear.toFixed(2)}</td>
                                    <td>{estimativas.estimativaTotalLinear.toFixed(2)}</td>
                                    <td>{estimativas.estimativaNovosCAGR.toFixed(2)}</td>
                                    <td>{estimativas.estimativaRenovadosCAGR.toFixed(2)}</td>
                                    <td>{estimativas.estimativaTotalCAGR.toFixed(2)}</td>
                                    <td>{estimativas.estimativaNovosMovel.toFixed(2)}</td>
                                    <td>{estimativas.estimativaRenovadosMovel.toFixed(2)}</td>
                                    <td>{estimativas.estimativaTotalMovel.toFixed(2)}</td>
                                    {/* <td>{estimativas.estimativaNovosARIMA.toFixed(2)}</td>
                                <td>{estimativas.estimativaRenovadosARIMA.toFixed(2)}</td>
                                <td>{estimativas.estimativaTotalARIMA.toFixed(2)}</td> */}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

}
export default Estimativa_geral;